<ng-container *ngIf="isLoggedInUser">
  <div class="row rfq-list-view">
    <div class="col-md-6">
      <a class="mini-quote-cart" (click)="navigateQuoteProducts($event)" (clickOutside)="navigationQuote($event)">
        <cx-icon [type]="iconTypes.ORDER"></cx-icon>
        <span class="count quote-count">
          <b>
            {{ (quoteCart$ | async)?.totalItems || 0 }}
          </b>
        </span>
      </a>
    </div>

    <div class="col-md-6">
      <a
        (click)="navigateProducts($event)"
        (clickOutside)="navigationOne($event)"
        class="mini-cart-icon-link"
        [attr.aria-label]="
          'miniCart.item' | cxTranslate: { count: quantity$ | async }
        "
      >
        <!-- [routerLink]="{ cxRoute: 'cart' } | cxUrl"-->
        <cx-icon [type]="iconTypes.CART"></cx-icon>
        <span class="count">
          <b>
            {{ cart?.totalItems ? cart.totalItems : 0 }}
          </b>
        </span>
      </a>
    </div>
  </div>

  <!-- <app-mini-cart-details (mouseenter)="isShowDivIf = false"></app-mini-cart-details> -->
  <div *ngIf="isShowDivIf">
    <vs-mini-cart-details
      (closeMiniCartDetails)="closeMiniCartDetails($event)"
    ></vs-mini-cart-details>
  </div>

  <div *ngIf="isShowQuoteDivIf">
    <vs-mini-quote-cart-details (miniQuoteCartReload)="miniQuoteCartReload($event)" (closeMiniQuoteCartDetails)="closeMiniQuoteCartDetails($event)"></vs-mini-quote-cart-details>
  </div>
</ng-container>

<!-- <span class="total">
    {{ 'miniCart.total' | cxTranslate: { total: total$ | async } }}
  </span> -->
